import { API_BASE_URL } from '..';
import api from '@/api';
import {
  UserWorkTimeControllerRequest,
  workTimeList,
} from './UserWorkTimeController.types';

const CONTROLLER_URL = `${API_BASE_URL}/user-work-time`;

export async function createUserWorkTime(obj: UserWorkTimeControllerRequest) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}

export async function getUserWorkTime(id?: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as workTimeList[];
}

export async function updateUserWorkTime(obj: UserWorkTimeControllerRequest) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}
export async function removeUserWorkTime(id?: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
